/**
 * The default app name for entity ducks
 *
 * @example
 * ts```
 * ExampleEntity.duck = new DjangoRestFramework({
 *   app: duckAppName,
 *   // ...
 * });
 * ```
 */
export const duckAppName = 'AppStore' as const;

export const logoutPathname = 'log-out';
export const logoutRoute = `/${logoutPathname}`;

export const notAllowedPathname = 'not-allowed';
export const notAllowedRoute = `/${notAllowedPathname}`;

export const loginRoute = '/login';

export const applicationsRoute = '/applications';
export const myApplicationsRoute = `${applicationsRoute}/mine`;
export const applicationRoute = (id: string) => `${applicationsRoute}/${id}`;
export const applicationConfigureRoute = (id: string) =>
  `${applicationRoute(id)}/configure`;

export const mockApisRoute = '/mock-apis';
export const mockSystemRoute = (id: string) => `${mockApisRoute}/${id}`;
export const mockEndpointRoute = (systemId: string, endpointId: string) =>
  `${mockSystemRoute(systemId)}/endpoints/${endpointId}`;

/**
 * @example
 * ```tsx
 * moment().format(DATE_FORMAT);
 * record?.get('my_date_field')?.format(DATE_FORMAT);
 * ```
 * @see https://momentjs.com/docs/#/displaying/format/
 */
export const DATE_FORMAT = 'DD/MM/YYYY HH:mm' as const;
